import React from "react";
import "./home.scss";
import Navbar from "../Section/Navbar/navbar.jsx";
import Banner from "../Section/Banner/banner.jsx";
import About from "../Section/About/about.jsx";
import Livia from "../Section/Livia/Livia.jsx";
import NewLivia from "../Section/Newlivia/Newlivia.jsx";
import New from "../Section/New/New.jsx";

import Promo from "../Section/Promo/promo.jsx";
import Soon from "../Section/comingsoon/soon.jsx";
import Produk from "../Section/Produk/Produk.jsx";
import Rumah from "../Section/Rumah/rumah.jsx";
import Ruko from "../Section/Ruko/ruko.jsx";
import Lokasi from "../Section/Lokasi/lokasi.jsx";
import Footer from "../Section/Footer/footer.jsx";
import tombol from "../media/tombol.webp";
import ScrollToHashElement from "./ScrollToHashElement.js";

const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281574115424&text=Halo+Radi%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Grand%20Wisata%20https://www.grandwisata-marketing.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <ScrollToHashElement />
      <Navbar />
      <Banner />
      <About />

      <Promo />
      <NewLivia />
      <Livia />
      <New />
      <Soon />
      <Produk />
      <Rumah />
      <Ruko />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        alt={tombol}
        className="tombolwa"
      />
    </div>
  );
};

export default home;
